module.exports = __webpack_public_path__ + "img/img3.f47df40f.png";